const COMBINING_DIACRITICS = /[̀-ͯ]/g;

function slugify(text: string): string {
  return text
    .normalize("NFD")
    .replace(COMBINING_DIACRITICS, "")
    .toLowerCase()
    .replace(/&/g, "et")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** e.g. buildPhotoFilename("Agathe & Florian", "05/06/2027", 3, "jpg") -> "agathe-et-florian-05062027-03.jpg" */
export function buildPhotoFilename(
  coupleNames: string,
  weddingDate: string,
  chronologicalIndex: number,
  extension: string,
): string {
  const namesSlug = slugify(coupleNames) || "mariage";
  const dateSlug = weddingDate.replace(/\D/g, "");
  const prefix = [namesSlug, dateSlug].filter(Boolean).join("-");
  const numbered = String(chronologicalIndex).padStart(2, "0");
  return `${prefix}-${numbered}.${extension}`;
}

export function extensionFromUrl(url: string): string {
  return url.split(".").pop() ?? "jpg";
}
